import { INSURANCE_ELIGIBILITY_FIELDS_TYPES } from '../formFields';

const {
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  DOB,
  DO_NOT_HAVE_INSURANCE,
  FIRST_NAME,
  GENDER,
  GROUP_NUMBER,
  HEALTH_PLAN,
  INSURANCE_RELATION_ID,
  LAST_NAME,
  MEMBER_ID,
  PHONE_NUMBER,
  POSTAL_CODE,
  PRIMARY_SUBSCRIBER,
  STATE,
} = INSURANCE_ELIGIBILITY_FIELDS_TYPES;

export const INITIAL_INSURANCE_FORM_STATE = {
  [ADDRESS_1]: '',
  [ADDRESS_2]: '',
  [CITY]: '',
  [DOB]: null,
  [DO_NOT_HAVE_INSURANCE]: false,
  [FIRST_NAME]: '',
  [GENDER]: '',
  [GROUP_NUMBER]: '',
  [HEALTH_PLAN]: null,
  [INSURANCE_RELATION_ID]: '',
  [LAST_NAME]: '',
  [MEMBER_ID]: '',
  [PHONE_NUMBER]: '',
  [POSTAL_CODE]: '',
  [PRIMARY_SUBSCRIBER]: true,
  [STATE]: '',
};



// WEBPACK FOOTER //
// ./src/constants/insurance/initial-insurance-form-state.js